import { Checkbox, FormControlLabel } from "@mui/material";
import { Controller } from "react-hook-form";

import type { CustomFieldComponentProps } from "../types";

const CheckboxComponent = ({
  field,
  methods,
}: CustomFieldComponentProps<"checkbox">): React.JSX.Element => (
  <Controller
    name={field.name}
    control={methods.control}
    defaultValue={field.defaultValue || false}
    render={({ field: { onChange, ...controllerField } }) => (
      <FormControlLabel
        control={
          <Checkbox
            {...controllerField}
            checked={Boolean(controllerField.value)}
            disabled={field.disabled}
            onChange={(e, checked) => {
              field.onChange?.(e, checked);
              onChange(e, checked);
            }}
          />
        }
        label={field.label}
        className={field.className}
        style={field.style}
      />
    )}
  />
);

export default CheckboxComponent;
